import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { CircularExampleTileProps } from './circular-example-tile.types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { GTM_ID } from '../../../../../common/constants/gtmIds';
import { H3Atom, PAtom, MissingLocaleAtom } from '@atoms/text-atoms/text-atoms';
import { InternalLinkAtom } from '@atoms/link-atoms/link-atoms';

const CircularExampleTile: React.FC<CircularExampleTileProps> = ({
  title = '',
  gatsbyImageData = {},
  imageUrl = '',
  imageAlt = '',
  imageFormat,
  url = '',
  tileType = 'standard',
  className,
  localeCode = 'en-GB',
  translate = true,
  localeUnavailable = false,
}) => {
  const gatsbyImage = getImage(gatsbyImageData);

  return (
    <InternalLinkAtom
      dataTestId="circular-example-tile-container"
      className={className}
      url={url}
      gtmId={GTM_ID.CIRCULAR_EXAMPLE_LINK}
    >
      {gatsbyImage &&
      imageFormat !== 'image/gif' &&
      imageFormat !== 'image/svg+xml' ? (
        <GatsbyImage
          image={gatsbyImage}
          alt={imageAlt}
          className="gatsby-image-pos"
        />
      ) : (
        <div className="gatsby-image-wrapper gatsby-image-wrapper-constrained gatsby-image-pos">
          {imageUrl && <img src={imageUrl} alt={imageAlt} />}
        </div>
      )}

      <H3Atom data-testid="circular-example-tile">
        <span>{title}</span>
      </H3Atom>
      {localeUnavailable && (
        <MissingLocaleAtom localeCode={localeCode} translate={translate} />
      )}
    </InternalLinkAtom>
  );
};

const StyledCircularExampleTile = styled(CircularExampleTile)`
  height: 14.9rem;
  width: 26.6rem;
  display: block;
  overflow: hidden;
  position: relative;
  border: 1.3px solid ${vars.white};
  background: white;
  box-sizing: border-box;

  img {
    transition: transform ${vars.defaultTransition};
    z-index: 10;
    height: 100%;
    min-width: 100%;
    opacity: ${({ localeUnavailable }) => (localeUnavailable ? 0.6 : 1)};
  }

  &:hover {
    img {
      transform: ${vars.imageHoverScale};
    }
    ${MissingLocaleAtom} {
      background: ${vars.coreDarkGrey};
      ${PAtom} {
        color: white;
      }
    }
  }

  .gatsby-image-pos {
    position: absolute;
    transition: ${vars.defaultTransition};
    img {
      transition: ${vars.defaultTransition};
      position: absolute;
    }
  }

  ${H3Atom} {
    max-width: 16rem;
    position: absolute;
    left: 1.8rem;
    bottom: 1.8rem;
    padding-bottom: 0px;
    padding-left: 2px;
    opacity: ${({ localeUnavailable }) => (localeUnavailable ? 0.6 : 1)};
    span {
      background-color: ${vars.white};
      box-shadow:
        0.8rem 0 0 white,
        -0.8rem 0 0 white;
      font-family: inherit;
      letter-spacing: -0.02rem;
      line-height: 1.75;
      ${vars.fontSize2}
      margin: 0;
      padding: 0.4rem 0;
    }
  }
`;

export default StyledCircularExampleTile;
